import { Component, Input, Output,  EventEmitter, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-alert-box-component',
  templateUrl: './alert-box-component.component.html',
  styleUrls: ['./alert-box-component.component.scss']
})
export class AlertBoxComponentComponent {
  @Input() closeButtonText: string = 'Close'
  @Input() secondButtonText: string = 'Understood'

  @Input() alertHeaderText: string = ''
  @Input() alertBodyText: string = ''
  @Input() bShowSecondButton: boolean
  @Input() bAlert: boolean
  @Input() data: any

  @Output() OnAlertVisibility = new EventEmitter()
  @Output() OnAlertClose = new EventEmitter()
  @Output() OnButtonClick = new EventEmitter()

  constructor(@Inject(DOCUMENT) private document: Document, private renderer: Renderer2){
    this.bAlert = false
    this.bShowSecondButton = false
  }

  visibleChange(visiblity: boolean) {
    this.bAlert = visiblity
    this.OnAlertVisibility.emit({state: visiblity, data: this.data})
  }

  hideAlert()
  {
    this.renderer.removeStyle(document.body, 'overflow')
    this.bAlert = false
    this.OnAlertClose.emit({state: this.bAlert, data: this.data})
  }

  secondButton()
  {
    this.renderer.removeStyle(document.body, 'overflow')
    this.bAlert = false
    this.OnButtonClick.emit({state: this.bAlert, data: this.data})
  }

  getAlertState()
  {
    return this.bAlert
  }
}
